import { call } from 'redux-saga/effects';
import { authService } from '../utils/auth-service';
import { timeout } from '../utils/helper-functions';

export function* loadAuthToken() {

  const token = authService.getToken();

  if (!token) {

    timeout(1000);
    yield call(loadAuthToken);
  } else {

    return token;
  }
}



/** WEBPACK FOOTER **
 ** ./src/sagas/auth-token.js
 **/